import { IS_VATAR } from './env';

// Payments must only go through Vatar.purchase (Developer Agreement 4(g), 5.1),
// so every checkout surface renders nothing in the Vatar build.
export default function hiddenInVatar(Component) {
  const Wrapped = (props) => (IS_VATAR ? null : <Component {...props} />);
  Wrapped.displayName = `hiddenInVatar(${Component.displayName || Component.name || 'Component'})`;
  return Wrapped;
}
